import { $api } from '../y/api';
import { YId } from '../y/types';

export function meInboxSeen(id: YId) {
    return $api.POST(`me/inbox/${id}/seen`);
}
